import BG from '~/components/background';
import ProForm from '~/events/2021/01/event-pro/pro-form';
import top from "../../../../src/events/2021/01/event-pro/images/top.png";
import bottom from "../../../../src/events/2021/01/event-pro/images/bottom.png";
import * as React from 'react';
export default {
  BG,
  ProForm,
  top,
  bottom,
  React
};